module.exports = __webpack_public_path__ + "img/WhatsApp Image 2025-08-06 at 12.38.24 PM.350163b0.jpeg";